// src/com/auto_dida_info/AutoDidaCountTree.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { AppObject, AppStyle } from '../../value/AppConst';

const DcBox = styled(Box)({fontSize: '0.9rem', padding: 5});
const WeeksBox = styled(Box)({paddingLeft:40});

const WeekItem = styled(Box)({
    display: 'flex', alignItems: 'center', fontSize: '0.8rem', padding: 5,
    '&:hover': {backgroundColor: '#eee'}
});

const WeekLabel = styled('div')({
    flexGrow: 1,
});

const WeekCount = styled('div')({
    color: AppStyle.PrimaryRGB
});

export default function AutoDidaCountTree({
    list,
    onClickDc,
}) {
    const [tree, setTree] = useState({});

    useEffect(()=>{
        if(list && list.length > 0) {
            // tree of dc and weekDay
            const dcTree = {};
            const countForDc = {};
            list.forEach(item=>{
                const {dcCd, dcName, weekDay, didaCount} = item;
                const dayName = AppObject.weekChars[weekDay] + '요일';
                if(!dcTree[dcCd]) {
                    dcTree[dcCd] = {dcCd, dcName, days:{}};
                }
                dcTree[dcCd].days[weekDay] = {dayName, didaCount};

                if(!countForDc[dcCd]) countForDc[dcCd] = 0;
                countForDc[dcCd] += didaCount;
            });
            // add total count
            for(const dcCd in countForDc) {
                dcTree[dcCd].total = countForDc[dcCd];
            }
            setTree(dcTree);
        }
    }, [list]);

    return(
        <Box
            style={{
                position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                overflow: 'auto', 
            }}
        >
            {
                Object.values(tree).sort((a,b)=>a.dcName.localeCompare(b.dcName)).map((dc, idx)=>{
                    return(
                        <Box key={idx}>
                            <DcBox>
                                <Button
                                    variant={AppStyle.mui.text}
                                    onClick={()=>onClickDc(dc)}
                                >
                                    {dc.dcName}
                                </Button>
                            </DcBox>
                            <WeeksBox>
                                <WeekItem
                                    style={{
                                        borderRadius: 15,
                                        border: AppStyle.BorderCCC,
                                    }}
                                >
                                    <WeekLabel style={{color:'#666'}}>- 요일</WeekLabel>
                                    <WeekCount>점포*일</WeekCount>
                                </WeekItem>
                                {
                                    Object.values(dc.days)
                                    .sort((a,b)=>a.weekDay-b.weekDay)
                                    .map((day, index)=>{
                                        return(
                                            <WeekItem key={index}>
                                                <WeekLabel>- {day.dayName}</WeekLabel>
                                                <WeekCount>{day.didaCount}</WeekCount>
                                            </WeekItem>
                                        )
                                    })
                                }
                                <WeekItem style={{borderTop: '1px solid ' + AppStyle.PrimaryRGB}}>
                                    <WeekLabel style={{color:'#666'}}>+ Sum</WeekLabel>
                                    <WeekCount>{dc.total}</WeekCount>
                                </WeekItem>
                            </WeeksBox>
                        </Box>
                    )
                })
            }
        </Box>
    );
}